export class SystemadministrationTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        kundorder: "KUNDORDER",
        omkorningAvKopplaKundorderHS: "Omkörning av koppla Kund/Kundorder och HS Produkt",
        leveransmatningar: "LEVERANSMÄTNINGAR",
        huvudkodInternnummer: "HUVUDKOD-INTERNNUMMER",
        mottagningsplatsnummer: "MOTTAGNINGSPLATSNUMMER",
        matdatumFrom: "MÄTDATUM FR.O.M.",
        matdatumTom: "MÄTDATUM T.O.M.",
        transaktionsdatumFrom: "TRANSAKTIONSDATUM FR.O.M.",
        transaktionsdatumTom: "TRANSAKTIONSDATUM T.O.M.",
        atgarderLadesPaKo: " åtgärder lades på kö för inläsning.",
        avdelningLadesPaKo: " avdelning lades på kö för inläsning.",
        prolog: "Prolog",
        produktinstruktioner: "Produktinstruktioner",
        basladdaAllaProduktinstruktioner: "Basladda alla produktinstruktioner",
        uppdateraProduktinstruktioner: "Uppdatera produktinstruktioner",
        updatedProduktinstruktioner: " produktinstruktion(er) uppdaterade.",
        addedProduktinstruktioner: " produktinstruktion(er) importerade."
    };
}
